import type { SsoUser } from '@domain/entities';
import type { IUserRepository } from '@domain/repositories';
import type { ResetPasswordResult } from '@application/dto';

/**
 * Asigna una clave temporal al usuario. La consola la muestra una sola vez: el
 * admin se la pasa al usuario, que en el proximo login elige una nueva.
 */
export class ResetUserPasswordUseCase {
  constructor(private readonly userRepository: IUserRepository) {}

  async execute(user: SsoUser): Promise<ResetPasswordResult> {
    return this.userRepository.resetPassword(user.id);
  }
}
